import List from './List';
import reducer from './reducer';

const Orders = {
  List,
  reducer
};

export default Orders;
